// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"style_tabsContainer__OP0_C","header":"style_header__mWaiQ","tabs":"style_tabs__PjniW"};